import state from './state';
import sign from '../mixins/http/sign';

const getters = {};

Object.keys(state).map(key => {
  getters[key] = state => state[key];
});

const signGetters = {};

// 获取加密保存的数据（需要在set时先加密）
[].map(k => {
  signGetters[k] = (state) => {
    if (state[k]) {
      return JSON.parse(sign.base64_decode(state[k]));
    } else {
      return {};
    }
  }
});

const getSession = (state, prop, key) => {
  let curr = null;
  try {
    curr = sessionStorage.getItem(prop);
    curr = curr && JSON.parse(curr);
  } catch (error) {}
  return state[key] || curr || null;
}


Object.assign(getters, signGetters, {
  currAudio(state) {
    return getSession(state,'audio', 'currAudio');
  },
  showUserGift(state) {
    return getSession(state,'gift', 'showUserGift');
  },
});

export default getters;
